var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('con-tab',{on:{"TwoClick":_vm.TwoClick}}),_c('XQ')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }